import * as React from 'react';
import { JobCenterModelInterface } from '../../Model/JobCenterModelInterface';
import { Type, typeFromModel } from '../../Type';
import { AbstractSharingLink } from './AbstractSharingLink';

export class EmailLink extends AbstractSharingLink {
    public render() {
        const model = this.props.model;
        const localUri = this.buildSharingUri(model);
        const title = this.context.i18n.translate('Per E-Mail teilen');

        const uri = 'mailto:?'
            + 'subject=' + encodeURIComponent(this.getSubject(model))
            + '&'
            + 'body=' + encodeURIComponent(localUri);

        return <div className="jc-share-link -email">
            <a href={uri} target="_blank" rel="noopener noreferrer" title={title}>
                <i className="fas fa-envelope"/>
            </a>
        </div>;
    }

    private getSubject(model: JobCenterModelInterface): string {
        switch (typeFromModel(model)) {
            case Type.Candidate:
                return this.context.i18n.translate('Interessanter Job-Kandidat: %s', [model.title]);
            case Type.JobVacancy:
                return this.context.i18n.translate('Interessantes Stellenangebot: %s', [model.title]);
        }
    }
}
